const parseCreditValue = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) && parsedValue >= 0 ? parsedValue : 0;
};

export const getAvailableDesignerCredits = (user) =>
  parseCreditValue(user?.organization?.freeDesignerCredits) +
  parseCreditValue(user?.organization?.paidDesignerCredits);

export const getDesignCreditsLabel = (credits) => {
  const creditLabel = credits === 1 ? 'Design Credit' : 'Design Credits';
  return `${credits} ${creditLabel} Available`;
};
